import React from 'react'
import DateTimePicker from 'material-ui-datetimepicker'
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog'
import brandTheme from '../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const TemporaryDateTimePickerUnstyled = props => {
  return (
    <div className={props.className}>
      {props.label && (
        <label className="label" htmlFor={props.id}>
          {props.label}
        </label>
      )}
      <DateTimePicker
        id={props.id}
        format="DD/MM/YYYY hh:mm a"
        value={props.input.value}
        onChange={props.input.onChange}
        clearIcon={null}
        DatePicker={DatePickerDialog}
        TimePicker={TimePickerDialog}
        textFieldStyle={{
          position: 'relative',
          width: '100%',
          borderRadius: '4px',
          height: '52px',
          background: '#F8F8F8',
          border: 'none',
          padding: '0 20px',
          color: colors.secondary,
          outline: 'none',
          ...props.textFieldStyle,
        }}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Form/TemporaryDateTimePicker/unstyled.js